import React from 'react';
import styles from './Popup.module.css';

export default function Popup({ active, setActive, children }) {
  const handleClose = () => {
    setActive(false);
  };
  return (
    <div style={{ display: active ? 'block' : 'none' }}
      className='popup-topdiv'>
      <div
        className={
          active ? styles.popupDarkBackgroundActive : styles.popupDarkBackground
        }
      >
        <div
          className={active ? styles.modalContentActive : styles.modalContent}
          onClick={e => e.stopPropagation()}>
          <div className='circlebox'>
            <div className='circlecontaner' onClick={handleClose} style={{ cursor: 'pointer' }}>X</div>
          </div>
          {children}
        </div>
      </div>
    </div>

  );
}
